import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { County } from '../models/County';

@Injectable()
export class CountyService {
  constructor(private http: Http) {}

  getByState(stateId: number): Observable<any> {
    const url = environment.api.baseUrl + environment.api.county.replace('{state}', stateId.toString());
    return this.http.get(url).map(res => {
      return res.json().map(j => new County(j));
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/county.service.ts